type StopPropagationEvent = { stopPropagation(): void };

export function withStopPropagation<E extends StopPropagationEvent>(
  handler: ((event: E) => void) | undefined,
  stopPropagation: boolean | undefined,
): ((event: E) => void) | undefined {
  if (!stopPropagation && !handler) {
    return undefined;
  }

  return (event: E) => {
    if (stopPropagation) {
      event.stopPropagation();
    }
    handler?.(event);
  };
}
